import { render, staticRenderFns } from "./SpecialistLicenses.vue?vue&type=template&id=3b34e91c&scoped=true"
import script from "./SpecialistLicenses.vue?vue&type=script&lang=js"
export * from "./SpecialistLicenses.vue?vue&type=script&lang=js"
import style0 from "./SpecialistLicenses.vue?vue&type=style&index=0&id=3b34e91c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b34e91c",
  null
  
)

export default component.exports